import { WebRTC } from "../../libs/webRTC";
import { SignalingCandidateResponse } from "../../proto/SignalingCandidate_pb";
import BaseHandler from "../BaseHandler";

export default class HandleSignalingCandidateResponse extends BaseHandler<SignalingCandidateResponse> {
  handle() {
    const signalingCandidateResponse = this.response.toObject();
    WebRTC.instance.onCandidate(signalingCandidateResponse.peerCandidate, signalingCandidateResponse.peerSdpMLineIndex, signalingCandidateResponse.peerSdpMId);
  }
}
